import Errors from 'app/interface/redux/types/core/errors'

const Default: Errors = []

export default Default
